import MultiSession       from './alerts/multi-session';
import NLeftContent       from './alerts/n-left-content';
import LastContent        from './alerts/last-content';

let ALERT_WALL_TYPES = '';
const rtimWall = window.vocento.__PROVIDER__.paywall.rtimWall;
if(rtimWall === true) {
  ALERT_WALL_TYPES = {
    'multi-session': MultiSession
  };
}else{
  ALERT_WALL_TYPES = {
    'multi-session': MultiSession,
    'n-left-content': NLeftContent,
    'last-content': LastContent
  };
}
export const ALERT_TYPES = ALERT_WALL_TYPES;

const Factory = Object.freeze({
  createAlerts() {
    return Object.keys(ALERT_TYPES).map((type) => {
      if (!ALERT_TYPES.hasOwnProperty(type)) {
        throw Error('[Paywall] alert type not found');
      }
      return new ALERT_TYPES[type](...arguments);
    });
  }
});

export default Factory;



// WEBPACK FOOTER //
// ./src/paywall-factory.js